module.exports = __webpack_public_path__ + "static/img/4-2-1.a327589c.jpg";